/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);

      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click',  '[data-show-search-trigger]', function(){
      window.PXUTheme.jsHeader.showSearch();
    });

    // Disclosure-pattern handler: click + keyboard on top-level <button>
    // disclosure triggers. Single delegated binding at document level so it
    // does not need re-registration across sticky transitions or theme-editor
    // reloads. Click-outside and global Escape are registered once below.
    window.PXUTheme.jsHeader.initDisclosureHandlers();

    if (this.dropdown_click === false) {
      // Hover-mode enhancement: write aria-expanded on mouseenter / mouseleave
      // so AT users see the same state CSS :hover shows visually. Short close
      // delay allows cursor travel between trigger and panel.
      window.PXUTheme.jsHeader.initHoverMode();
    }

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        window.PXUTheme.jsHeader.showSearch();
      }
    });

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }
  },
  openPanel: function($btn) {
    $btn.attr('aria-expanded', 'true');
    var panelId = $btn.attr('aria-controls');
    if (panelId) $('#' + panelId).removeAttr('hidden');
    var $item = $btn.closest('.navbar-item');
    $item.addClass('is-opened');
    if ($item.hasClass('has-mega-menu')) {
      $item.find('.mega-menu__section').addClass('is-active');
    }
  },
  closePanel: function($btn) {
    $btn.attr('aria-expanded', 'false');
    var panelId = $btn.attr('aria-controls');
    if (panelId) $('#' + panelId).attr('hidden', '');
    var $item = $btn.closest('.navbar-item');
    $item.removeClass('is-opened');
    $item.find('.mega-menu__section').removeClass('is-active');
  },
  closeAllPanels: function() {
    var self = this;
    $('.navbar-item .header__link[aria-expanded="true"]').each(function() {
      self.closePanel($(this));
    });
  },
  initDisclosureHandlers: function() {
    var self = this;
    var triggerSelector =
      '.navbar-item.has-dropdown > .header__link[aria-expanded], ' +
      '.navbar-item.has-mega-menu > .header__link[aria-expanded]';

    // Click toggles the panel. Bound once at document level so sticky-header
    // transitions and theme-editor reloads do not strand handlers.
    $(document).off('click.a11yDisclosure').on('click.a11yDisclosure', triggerSelector, function(e) {
      var $btn = $(this);
      var expanded = $btn.attr('aria-expanded') === 'true';
      self.closeAllPanels();
      if (!expanded) self.openPanel($btn);
    });

    // Keydown on the trigger button itself: Escape closes; Enter/Space are
    // handled natively by <button> via the click event above, so no extra
    // work is needed here.
    $(document).off('keydown.a11yDisclosureTrigger').on('keydown.a11yDisclosureTrigger', triggerSelector, function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var $btn = $(this);
        if ($btn.attr('aria-expanded') === 'true') {
          self.closePanel($btn);
          e.preventDefault();
        }
      }
    });

    // Click-outside closes any open panel. Registered ONCE.
    $(document).off('click.a11yDisclosureOutside').on('click.a11yDisclosureOutside', function(e) {
      if (!$(e.target).closest('.navbar-item').length) {
        self.closeAllPanels();
      }
    });

    // Global Escape: closes any open panel and returns focus to the
    // associated trigger button.
    $(document).off('keydown.a11yDisclosureGlobal').on('keydown.a11yDisclosureGlobal', function(e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      var $openTrigger = $('.navbar-item .header__link[aria-expanded="true"]');
      if ($openTrigger.length) {
        self.closePanel($openTrigger);
        $openTrigger.first().trigger('focus');
      }
    });
  },
  initHoverMode: function() {
    var self = this;
    var HOVER_CLOSE_DELAY = 150;
    var hoverCloseTimers = new WeakMap();

    $('.navbar-item.has-dropdown, .navbar-item.has-mega-menu')
      .off('mouseenter.a11yHover mouseleave.a11yHover')
      .on('mouseenter.a11yHover', function() {
        var item = this;
        var timer = hoverCloseTimers.get(item);
        if (timer) {
          clearTimeout(timer);
          hoverCloseTimers.delete(item);
        }
        var $btn = $(item).children('.header__link[aria-expanded]').first();
        if ($btn.length && $btn.attr('aria-expanded') !== 'true') {
          self.openPanel($btn);
        }
      })
      .on('mouseleave.a11yHover', function() {
        var item = this;
        var existing = hoverCloseTimers.get(item);
        if (existing) clearTimeout(existing);
        var timer = setTimeout(function() {
          var $btn = $(item).children('.header__link[aria-expanded]').first();
          if ($btn.length && $btn.attr('aria-expanded') === 'true') {
            self.closePanel($btn);
          }
          hoverCloseTimers.delete(item);
        }, HOVER_CLOSE_DELAY);
        hoverCloseTimers.set(item, timer);
      });
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function(){
      $stickyEl.css('height', 'auto');
    }, 250)
  },
  enableSticky: function(offset) {
    let $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      // Get header height is sticky enabled
      if(window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      // Un-hide the mini cart when scrolled back to the top
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');

    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
        },
        afterShow: function() {
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
      })
    }
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off('mouseenter.a11yHover mouseleave.a11yHover mouseleave');
    $(document).off('click.a11yDisclosure click.a11yDisclosureOutside keydown.a11yDisclosureTrigger keydown.a11yDisclosureGlobal');
    $('#header').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
}

/******/ })()
;